

import React, { useState } from "react";
import envisionLogo from "../../../assets/images/Picture2.png";

export default function EmployeeHandbookBook() {
  // Start always on "OUR CORE OPERATING VALUES"
  const [page, setPage] = useState(1);
  const [animateKey, setAnimateKey] = useState(0);

  const pages = [
    { type: "cover" },
    {
      title: "OUR CORE OPERATING VALUES",
      desc: (
        <>
          <p>
            Our core operating values define who we are as an organization and
            guide our decisions.
          </p>
          <ul>
            <li>Integrity in all actions</li>
            <li>Respect for individuals</li>
            <li>Commitment to excellence</li>
          </ul>
        </>
      ),
    },
    {
      title: "FOREWORD",
      desc:
        "This handbook provides clarity on company policies, expectations, and culture.",
    },
    {
      title: "THE COMPANY",
      desc:
        "Envision Integrated Services delivers excellence through innovation and professionalism.",
    },
    {
      title: "ABOUT THE HANDBOOK",
      desc:
        "This handbook should be used as a reference throughout your employment.",
    },
    {
      title: "EMPLOYMENT",
      desc:
        "This section explains employment classifications and working conditions.",
    },
    {
      title: "MESSAGE FROM CEO",
      desc:
        "Together, we aim to build a culture of trust, growth, and collaboration.",
    },
    {
      title: "JOB RESPONSIBILITY LEVEL",
      desc:
        "Each role has defined responsibilities and accountability levels.",
    },
    {
      title: "EMPLOYMENT TERMS",
      desc:
        "Covers probation, confirmation, and working hours.",
    },
    {
      title: "WORK BEHAVIOR & PERFORMANCE",
      desc:
        "Professional behavior and performance excellence are expected.",
    },
    {
      title: "PERFORMANCE APPRAISAL",
      desc:
        "Performance reviews support growth and development.",
    },
    {
      title: "COMPENSATION",
      desc:
        "Explains salary structure and benefits.",
    },
    {
      title: "TERMINATION & CLOSING",
      desc:
        "Outlines exit procedures and formal closure of employment.",
    },
  ];

  const nextPage = () => {
    if (page < pages.length - 1) {
      setPage(page + 1);
      setAnimateKey((p) => p + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const prevPage = () => {
    if (page > 1) {
      setPage(page - 1);
      setAnimateKey((p) => p + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="handbook-container">
      {/* LEFT SIDEBAR PLACEHOLDER */}
      <div className="sidebar"></div>

      {/* BOOK */}
      <div className="book-wrapper">
        <div className="book">
          {/* LEFT FIXED COVER */}
          <div className="page cover">
            <img src={envisionLogo} alt="Logo" className="page-logo" />
            <div className="cover-content">
              <h1>ENVISION</h1>
              <h2>Integrated Services</h2>
              <p>Employee Handbook</p>
            </div>
          </div>

          {/* RIGHT ACTIVE PAGE */}
          <div
            key={animateKey}
            className="page inner right-page"
          >
            <img src={envisionLogo} alt="Logo" className="page-logo" />
            <div className="page-header">{pages[page].title}</div>
            <div className="page-text">{pages[page].desc}</div>
          </div>

          {/* CONTROLS */}
          <div className="controls">
            <button onClick={prevPage} disabled={page === 1}>
              ◀ Prev
            </button>
            <span>
              {page} / {pages.length - 1}
            </span>
            <button
              onClick={nextPage}
              disabled={page === pages.length - 1}
            >
              Next ▶
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Inter:wght@400;500&display=swap');

        * { box-sizing: border-box; }
        body { margin: 0; }

        .handbook-container {
          // display: flex;
          gap: 20px;
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
        }

        .sidebar {
          flex: 0 0 16.6667%;
        }

        .book-wrapper {
          flex: 0 0 83.3333%;
          display: flex;
          
        }

        .book {
          width: 100%;
          max-width: 1000px;
          height: 460px;
          display: flex;
          position: relative;
          perspective: 1600px;
        }

        .page {
          width: 50%;
          height: 100%;
          padding: 44px 28px 32px;
          border: 1px solid #e5e5e5;
          border-radius: 6px;
          background: #fff;
          position: relative;
          overflow: hidden;
          backface-visibility: hidden;
        }

        /* COVER */
        .cover {
          background: linear-gradient(180deg, #0d47a1, #102b5c);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }

        .cover-content { text-align: center; }
        .cover-content h1 { margin: 0; letter-spacing: 2px; }
        .cover-content h2 { margin-top: 6px; font-weight: 400; }

        .page-logo {
          position: absolute;
          top: 12px;
          left: 14px;
          width: 56px;
        }

        .page-header {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          margin-bottom: 12px;
          border-bottom: 1px solid #ccc;
          padding-bottom: 6px;
        }

        .page-text {
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          line-height: 1.7;
          color: #333;
          text-align: justify;
        }

        .page-text ul { padding-left: 18px; margin-top: 10px; }
        .page-text li { margin-bottom: 6px; }

        /* RIGHT PAGE DESKTOP FLIP */
        .right-page {
          position: absolute;
          left: 50%;
          top: 0;
          transform-origin: left;
          animation: flip 0.8s ease forwards;
        }

        @keyframes flip {
          0% { transform: rotateY(-180deg); }
          100% { transform: rotateY(0deg); }
        }

        /* CONTROLS */
        .controls {
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 14px;
          font-family: 'Inter', sans-serif;
        }

        .controls span { font-size: 14px; color: #333; }

        .controls button {
          padding: 8px 18px;
          background: #0d47a1;
          color: #fff;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
        }

        .controls button:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }

        /* 📱 MOBILE FIX — NO JUMP */
        @media (max-width: 480px) {
          .book {
            flex-direction: column;
            height: auto;
          }

          .page {
            width: 100%;
          }

          .right-page {
            position: relative;
            left: 0;
            animation: slideDown 0.45s ease forwards;
          }

          @keyframes slideDown {
            0% {
              opacity: 0;
              transform: translateY(30px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        }
      `}</style>
    </div>
  );
}
